import React, { useState, useEffect } from 'react';
import { FilterGroups } from '@folio/stripes/components';
import { getStatusButtonElem } from '../../../utils';
export var Filters = function (_a) {
    var config = _a.config, filters = _a.filters, onChangeFilter = _a.onChangeFilter, onClearFilter = _a.onClearFilter;
    var _b = useState(false), focused = _b[0], setFocused = _b[1];
    useEffect(function () {
        if (focused) {
            return;
        }
        var firstFilterButton = getStatusButtonElem();
        if (firstFilterButton) {
            firstFilterButton.focus();
            setFocused(true);
        }
    });
    return (React.createElement("div", { id: "mainFiltersWrapper" },
        React.createElement(FilterGroups, { config: config, filters: filters, onChangeFilter: onChangeFilter, onClearFilter: onClearFilter })));
};
